<script setup lang="ts">
import AppLayout from './components/AppLayout.vue';
import LandingLayout from './components/LandingLayout.vue';
import AuthLayout from './components/AuthLayout.vue';
import ErrorLayout from './components/ErrorLayout.vue';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import ConfirmPopup from 'primevue/confirmpopup';
import DynamicDialog from 'primevue/dynamicdialog';
import Toast from 'primevue/toast';

const { currentRoute } = useRouter();

const layout = computed(() => currentRoute.value.meta.layout);
</script>

<template>
    <AppLayout v-if="layout === 'app'" />
    <LandingLayout v-else-if="layout === 'landing'" />
    <ErrorLayout
        v-else-if="
            layout === 'error' ||
            layout === 'exception' ||
            layout === 'not-found' ||
            layout === 'access-denied'
        "
    />
    <AuthLayout v-else-if="layout === 'auth'" />
    <router-view v-else></router-view>
    <ConfirmPopup />
    <DynamicDialog />
    <Toast />
</template>
